import React, { useEffect, useState } from 'react';
import { GetRouteSummaries } from '../../services/tpcPortalService';
import { RouteScanSummary } from '../../models/RouteScanSummary';
import RouteScanSummaryView from './RouteScanSummaryView';
import FullScreenOptionPicker from '../Common/FullScreenOptionPicker';
import { useNavigate } from 'react-router';

function RouteScanSummariesView() {

    const navigate = useNavigate();

    const [routeScanSummaries, setRouteScanSummaries] = useState<RouteScanSummary[]>([])

    const getRouteSummaries = async () => {
        const routeSummaries = await GetRouteSummaries();
        setRouteScanSummaries(routeSummaries); 
    }

    useEffect(() => { 
        getRouteSummaries();
    }
    ,[])

    const [currentMenuOpen, setCurrentMenuOpen] = useState<string>("")

    const openMenu = async (openMenu: string) => {
        setCurrentMenuOpen(openMenu);
    }

    const closeMenu = async () => {
        setCurrentMenuOpen("")
    }

    const OpenRouteMenu = async () =>
    {
        openMenu("route")
    }

    const routeSelected = async (route: string) => {
        navigate("/route/" + route);
    }

    return (
        <div className="grid grid-cols-6 text-center text-md sm:text-1xl md:text-2xl lg:text-3xl xl:text-4xl">
            { currentMenuOpen === "" &&
            <div className="grid grid-cols-6 col-span-6">
            <div className="col-span-2 cursor-pointer" onClick={OpenRouteMenu}>Route</div>
            <div className="col-span-1">Green Scans</div>
            <div className="col-span-1">Yellow Scans</div>
            <div className="col-span-1">Red Scans</div>
            <div className="col-span-1">Assigned Parcels</div>
            <ul className="col-span-6">
                <div>
                {routeScanSummaries.map((rs, idx) =>
                    <RouteScanSummaryView key={idx} routeScanSummary={rs} /> 
                )}
                </div>
            </ul>
            </div>
            }
            {
                currentMenuOpen !== "" &&
                GetFullScreenOptionDisplay(currentMenuOpen)
            }
        </div>
            );

            function GetFullScreenOptionDisplay(openMenu: string)
            {
                return( 
                    <div className="col-span-6">
                        {
                            <FullScreenOptionPicker 
                                title="Select route"
                                className="bg-gray-200 cursor-pointer"
                                options={routeScanSummaries.map((rs) => rs.routeNumber)}
                                optionsClassName="bg-gray-300 hover:bg-blue-400 py-2"
                                cancelText="Cancel"
                                onCancel={closeMenu}
                                onSelected={routeSelected}
                            ></FullScreenOptionPicker>
                        }
                    </div> 
                )
            }

}

export default RouteScanSummariesView;